import { useEffect, useRef } from "react";
import SuccessToast from "../toasts/SuccessToast";
import MqttManager from "../../mqtt/Base";

const EventScenarioLearnCodeModal = ({
  setEventScenarioLearnCodeModal,
  eventScenarioLearnCodeModalRef,
}) => {
  const modalName = useRef(null);
  const mqttManager = new MqttManager();
  const client = useRef();

  useEffect(() => {
    setEventScenarioLearnCodeModal(modalName);

    if (modalName.current) {
      const $modal = window.$(modalName.current);
      $modal.on("show.bs.modal", function () {
        // تنظیم تایمر برای بستن مدال بعد از 15 ثانیه
        const timer = setTimeout(() => {
          $modal.modal("hide");
        }, 15000);

        // پاکسازی تایمر هنگام بستن مدال
        $modal.on("hide.bs.modal", () => clearTimeout(timer));
      });

      return () => {
        $modal.off("show.bs.modal");
      };
    }
  }, []);

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleClickCancel = () => {
    eventScenarioLearnCodeModalRef.current.click();
  };

  return (
    <div
      className="modal fade"
      id="learnCodeModal"
      tabIndex="-1"
      aria-labelledby="learnCodeLabel"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="learnCodeLabel">
              یادگیری
            </h5>
            <button
              type="button"
              className="btn-close d-none"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={eventScenarioLearnCodeModalRef}
            ></button>
          </div>
          <div className="modal-body">
            <p>لطفا دکمه ریموت را بفشارید</p>
          </div>
          <div className="modal-footer">
            {/* <button
              type="button"
              className="btn btn-outline-success-app"
              onClick={handleClickCancel}
            >
              انصراف
            </button> */}
            <button className="btn btn-success-app" type="button" disabled>
              <span
                className="spinner-border"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventScenarioLearnCodeModal;
